import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FbTableListDashboardCardService {

  constructor(private httpClient: HttpClient) { }

  getDetails(apiValue: string) {
    return this.httpClient.get(`/vd/formBuilder/dashboard/${apiValue}`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response?.data?.length > 0 && response.status === 200) {
            return response.data;
          } else {
            return []
          }
        }),
        catchError(error => {
          return of([]);
        })
      );
  }

  getPostDetails(apiValue: string, payload: any) {
    return this.httpClient.post(`/vd/formBuilder/dashboard/${apiValue}`, payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response?.data?.length > 0 && response.status === 200) {
            return response.data;
          } else {
            return []
          }
        }),
        catchError(error => {
          return of([]);
        })
      );
  }

  getGroupReferenceData(groupReferenceCode: string, filterIndex: any) {
    return this.httpClient.get(`/referenceLibrary/${groupReferenceCode}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response?.data?.length > 0 && response.status === 200) {
          return {
            data: response.data,
            index: filterIndex
          };
        } else {
          return {
            data: [],
            index: filterIndex
          };
        }
      }),
      catchError(error => {
        return of({
          data: [],
          index: filterIndex
        });
      })
    );
  }

  getAPI(apiValue: string, filterIndex: any) {
    return this.httpClient.get(apiValue).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response?.data?.length > 0 && response.status === 200) {
          return {
            data: response.data,
            index: filterIndex
          };
        } if (response?.data?.positions?.length > 0 && response.status === 200) {
          return {
            data: response.data.positions,
            index: filterIndex
          };
        }
        else {
          return {
            data: [],
            index: filterIndex
          };
        }
      }),
      catchError(error => {
        return of({
          data: [],
          index: filterIndex
        });
      })
    );
  }

}
